const getMenuLabel = (ref) => {
    return ref.previousSibling;
};

export default getMenuLabel;
